module.exports = __webpack_public_path__ + "static/media/green-tick.8c8c8e89.svg";


//////////////////
// WEBPACK FOOTER
// ./public/images/green-tick.svg
// module id = 1617
// module chunks = 1